import { searchResult, analystforms } from '@/api'
import {
  SET_ANALYST_SEARCH,
  FETCH_ANALYST_BIO,
  LOAD_ANALYST_RESULT,
  SET_CURRENT_PAGE_ANALYST,
  SET_LOAD_MORE_STATUS_ANALYST,
  LOAD_MORE_RESULT_ANALYST,
  SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST,
  SUBMIT_ANALYST_CONTACT,
  GET_ENTITLED,
  ASK_ANALYST
} from '@/store/actions.type'
import localStorage from '@/api/localStorage'
import $ from 'jquery'

import {
  RESET_FILTER_ANALYST,
  GET_ANALYST_SEARCH_VALUE,
  LOAD_MORE_ANALYST_SEARCH_POST,
  SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER,
  SET_ANALYST_SEARCH_LOADING,
  GET_ANALYST_BIO,
  GET_ANALYST_BIO_LOADING,
  UPDATE_ELLIPSIS,
  SET_CURRENT_ANALYST_PAGE_VALUE,
  SET_LOAD_MORE_VALUE_ANALYST,
  LOAD_MORE_ANALYST_POST,
  SET_ORDER_BY_ANALYST,
  GET_SEARCH_VALUE_ANALYST,
  SET_ORDER_BY_VALUE_ANALYST,
  SET_LOCAL_TO_STORE_ANLYST
} from '@/store/mutations.type'
const analystHelper = {
  insertLocalStorage: function ( analystfilter ) {
    // ('save to analyst...', analystfilter)
    localStorage.savelocalStorage( 'analystTab', JSON.stringify( analystfilter ) )
  }
}
const state = {
  authorbio: {},
  filters: {},
  searchresult: '',
  searchfilters: {
    key: '',
    symbol: '',
    type: '',
    analyst: '',
    time: '',
    start_time: '',
    end_time: '',
    sort: 'desc',
    is_filter: '',
    category: '',
    search: '',
    currentpage: 1
  },
  searchresultloading: false,
  loadmore: false
}

const actions = {
  [SET_LOCALSTORAGE_SEARCH_FILTER_ANALYST]( { commit }, searchfilter ) {
    commit( SET_LOCAL_TO_STORE_ANLYST, searchfilter )
  },

  async [GET_ENTITLED]( { commit }, entitledobj ) {
    return analystforms.get_entitled( entitledobj ).then( ( { data } ) => {} )
  },
  async [ASK_ANALYST]( { commit }, entitledobj ) {
    return analystforms.ask_analyat( entitledobj ).then( ( { data } ) => {} )
  },
  async [SUBMIT_ANALYST_CONTACT]( { commit }, analystobject ) {
    return analystforms.contact_analyst( analystobject ).then( ( { data } ) => {} )
  },
  async [SET_ORDER_BY_ANALYST]( { commit }, orderby ) {
    commit( SET_ORDER_BY_VALUE_ANALYST, orderby )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      commit( GET_SEARCH_VALUE_ANALYST, JSON.parse( data ) )
      commit( SET_LOAD_MORE_VALUE_ANALYST, false )
    } )
  },

  async [LOAD_MORE_RESULT_ANALYST]( { commit } ) {
    commit( SET_ANALYST_SEARCH_LOADING, true )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      commit( LOAD_MORE_ANALYST_POST, JSON.parse( data ) )
      commit( SET_LOAD_MORE_VALUE_ANALYST, false )
      commit( SET_ANALYST_SEARCH_LOADING, false )
    } )
  },

  [SET_LOAD_MORE_STATUS_ANALYST]( { commit }, status ) {
    commit( SET_LOAD_MORE_VALUE_ANALYST, status )
  },
  [SET_CURRENT_PAGE_ANALYST]( { commit }, currentpage ) {
    commit( SET_CURRENT_ANALYST_PAGE_VALUE, currentpage )
  },
  [SET_ANALYST_SEARCH]( { commit }, searchkey ) {
    commit( SET_ANALYST_SEARCH_LOADING, true )
    commit( SET_CURRENT_ANALYST_PAGE_VALUE, 1 )
    commit( SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER, searchkey )
    analystHelper.insertLocalStorage( state.searchfilters )
    return searchResult.getSearchValue( state.searchfilters ).then( ( { data } ) => {
      // analystHelper.insertLocalStorage(state.searchfilters)
      commit( GET_ANALYST_SEARCH_VALUE, JSON.parse( data ) )
      commit( SET_ANALYST_SEARCH_LOADING, false )
    } )
  },
  [LOAD_ANALYST_RESULT]( { commit }, searchfilter ) {
    commit( SET_CURRENT_ANALYST_PAGE_VALUE, 1 )
    return searchResult
      .getSearchValue( JSON.parse( searchfilter ) )
      .then( ( { data } ) => {
        commit( GET_ANALYST_SEARCH_VALUE, JSON.parse( data ) )
        commit( SET_ANALYST_SEARCH_LOADING, false )
      } )
  },
  [FETCH_ANALYST_BIO]( { commit }, analystdetials ) {
    // console.log('analystid', analystid)
    var analystid = analystdetials['aid']
    var satelliteFlag = analystdetials['strack']
    commit( GET_ANALYST_BIO_LOADING, true )
    return searchResult.analystbio( analystid ).then( ( { data } ) => {
      digitalData.analystName = data.analystname
      if ( satelliteFlag ) {
        _satellite.track( 'researchView' )
      }

      commit( GET_ANALYST_BIO, data )
      commit( GET_ANALYST_BIO_LOADING, false )
    } )
  }
}
const mutations = {
  [RESET_FILTER_ANALYST]( state, value ) {
    state.searchfilters = {
      key: '',
      symbol: '',
      type: '',
      analyst: '',
      time: '',
      start_time: '',
      end_time: '',
      sort: 'desc',
      is_filter: '',
      category: '',
      search: '',
      currentpage: 1
    }
  },

  [SET_LOCAL_TO_STORE_ANLYST]( state, searchfilters ) {
    state.searchfilters = searchfilters
  },
  [SET_ORDER_BY_VALUE_ANALYST]( state, orderby ) {
    state.searchfilters.currentpage = 1
    state.searchfilters.sort = orderby
  },
  [GET_SEARCH_VALUE_ANALYST]( state, searchresult ) {
    state.searchresult = searchresult
  },
  [LOAD_MORE_ANALYST_POST]( state, searchresult ) {
    for ( var i = 0; i < searchresult.posts.length; i++ ) {
      state.searchresult.posts.push( searchresult.posts[i] )
    }
    state.loadmore = false
    state.searchresultloading = false
  },
  [SET_LOAD_MORE_VALUE_ANALYST]( state, value ) {
    state.loadmore = value
  },
  [SET_CURRENT_ANALYST_PAGE_VALUE]( state, value ) {
    state.searchfilters.currentpage = value
  },
  [SET_RESEARCH_TYPE_ANALYST_SEARCH_FILTER]( state, analyst ) {
    state.searchfilters.analyst = analyst
  },
  [GET_ANALYST_SEARCH_VALUE]( state, searchresult ) {
    state.searchresult = searchresult
  },
  [SET_ANALYST_SEARCH_LOADING]( state, value ) {
    state.searchresultloading = value
  },
  [GET_ANALYST_BIO]( state, value ) {
    state.authorbio = value
  },
  [GET_ANALYST_BIO_LOADING]( state, value ) {
    state.bioloading = value
  },
  [UPDATE_ELLIPSIS]() {
    $( '.ellipsis' ).each( function () {
      var p = $( this )
      var max_line_count = p.data( 'ellipsis-max-line-count' )
      var line_height = p.html( '&nbsp' ).outerHeight()
      var max_height = max_line_count * line_height
      p.html( p.data( 'ellipsis-storage' ) )
      var p_height = p.outerHeight()

      while ( p_height > max_height ) {
        var content_arr = p.html().split( ' ' )
        content_arr.pop()
        content_arr.pop()
        content_arr.push( '...' )
        p.html( content_arr.join( ' ' ) )
        p_height = p.outerHeight()
      }
    } )
  }
}

const getters = {
  analystsearchResultLoading( state ) {
    return state.searchresultloading
  },
  analystsearchstate( state ) {
    return state
  },
  analystdetials() {
    return state.authorbio
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/analyst.js